import ColumnBase from "./ColumnBase.jsx";
import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { ICON_COL_DEF_WIDTH } from "../../other/constants/OtherKeys.jsx";
import { defaultGroupRenderer, isMediaFile, openGeneralWidgetFromGridRecord } from "../../other/utils/utils.jsx";
import { WIDGET_REGISTRY } from "../../other/constants/EntityManagerConfig.tsx";
import { HasIconColumnTooltipMixin } from "./mixins/HasIconColumnTooltipMixin.jsx";
import {
  formatFileTooltipItems,
  handleFileTooltipClick,
  queryBoardFilesForEntity,
} from "../../other/utils/filesColumnUtils.ts";

const TOOLTIP_CLS = "swivu-media-files-icon-tooltip";

const getMediaIcon = (hasData = false) => {
  const color = hasData ? "text-[#0a88e9]" : "";
  return `<i class="${TOOLTIP_CLS} fa-regular fa-image ${color}"></i>`;
};

export default class MediaColumn extends HasIconColumnTooltipMixin(ColumnBase) {
  static get $name() {
    return "MediaColumn";
  }

  static get type() {
    return WIDGET_KEYS.mediaColumn;
  }

  static get defaults() {
    return {
      text: "Media",
      width: 30,
      minWidth: ICON_COL_DEF_WIDTH,
      editor: false,
      searchable: false,
      align: "center",
      field: "hasMediaFiles",
      cellCls: "cursor-pointer",
      cls: "swivu-icon-column",
      sealed: true,
      filterable: false,
      htmlEncode: false,
      renderer({ value }) {
        return getMediaIcon(value);
      },
      groupRenderer({ groupRowFor, ...rest }) {
        return defaultGroupRenderer({ groupRowFor: getMediaIcon(groupRowFor), ...rest });
      },
      headerRenderer() {
        return getMediaIcon();
      },
    };
  }

  getTooltipSelector() {
    return `.${TOOLTIP_CLS}`;
  }

  getTooltipItems(record) {
    return queryBoardFilesForEntity(this.project, record).filter((file) => isMediaFile(file));
  }

  formatTooltipItems(records) {
    return formatFileTooltipItems(records);
  }

  handleTooltipClick(event, _record) {
    handleFileTooltipClick(event, this);
  }

  onSwivuColumnClick(e) {
    openGeneralWidgetFromGridRecord(this.editorHandler, e.record, WIDGET_REGISTRY.media.id, {
      idSuffix: "media",
    });
  }
}

ColumnStore.registerColumnType(MediaColumn);
